import { useState } from "react";
import type { GridValidRowModel } from "@mui/x-data-grid-premium";
import { useTranslation } from "react-i18next";
import type { DataGridContextMenuProps } from "src/components/DataGrid/useDataGridRowContextMenu.tsx";
import { DeleteRecordConfirmation } from "src/admin/modals/DeleteRecordConfirmation/DeleteRecordConfirmation.tsx";
import { TranslationNamespaceEnum } from "src/lib/i18next/types.ts";
import { useDeleteOne } from "src/system/useDeleteOne.ts";

// Меню строки «Bearbeiten / Löschen» для списков, встроенных во вкладки формы (ResourceList),
// как у ModuleList: открывается левым кликом по строке, удаление — с подтверждением.
export const useEditDeleteContextMenu = <Row extends GridValidRowModel>({
  resource,
  onEdit,
}: {
  resource: string;
  onEdit: (row: Row) => void;
}): DataGridContextMenuProps<Row> => {
  const { t } = useTranslation(TranslationNamespaceEnum.Common);
  const [selectedRow, setSelectedRow] = useState<Row>();
  const { mutate: deleteOne } = useDeleteOne({ resource });

  return {
    selectedRow,
    onSelectedRowChange: setSelectedRow,
    items: [
      {
        key: "edit",
        label: t("actions.edit"),
        icon: <i className={"icon-15-edit"} />,
        onSelect: (row: Row) => onEdit(row),
      },
      {
        key: "delete",
        label: t("actions.delete"),
        icon: <i className={"icon-15-delete"} />,
        danger: true,
        ConfirmComponent: DeleteRecordConfirmation,
        onSelect: () => {},
        onConfirm: (row: Row) => {
          deleteOne(
            { id: row.id },
            { onSettled: () => setSelectedRow(undefined) },
          );
        },
      },
    ],
  };
};
